import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ProfileEventsHeader = styled(Typography)`
  font-size: 15px;
  line-height: 35px;
  background-color: ${colors.primary};
  color: ${colors.white};
  padding-left: 13px;
  border-radius: 4px 4px 0px 0px;
  font-weight: 700;
`

export const ProfileEventsContainer = styled('div')`
  padding: 12px;
  max-height: 158px;
  overflow: auto;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.1);
  ${(props: { isUpdated?: boolean }) => `border: 1px solid ${props.isUpdated ? colors.primary : '#dadada'};`}
  border-top: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
